import { CheckCircle2 } from "lucide-react";

const TRUST_ITEMS = [
  "DOT compliant",
  "ELD-fed tracking",
  "24/7 dispatch",
  "HazMat endorsed",
  "48-state coverage",
];

/**
 * Slow seamless marquee of trust items. The list is rendered twice and
 * translated -50% so the loop never shows a seam; `prefers-reduced-motion`
 * pauses it (CSS) and the full list remains readable.
 */
export function TrustCarousel() {
  return (
    <div className="marquee-mask relative overflow-hidden py-1">
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((copy) => (
          <div
            key={copy}
            aria-hidden={copy === 1}
            className="flex items-center gap-12 pr-12 text-sm font-medium text-brand-100"
          >
            {TRUST_ITEMS.map((t) => (
              <span key={t} className="flex items-center gap-2 whitespace-nowrap">
                <CheckCircle2 className="h-4 w-4 text-accent-400" /> {t}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
